export const coreAddresses = {
  balanceTracker: "0xAf5659428FEF1F6a701FaB46d8f3aF8371A9913D",
  eVaultFactory: "0xaf4B4c18B17F6a2B32F6c398a3910bdCD7f26181",
  eVaultImplementation: "0x29E9b639e165d919FEcf02521F8A9dA0492D4f21",
  eulerEarnFactory: "0x574B00f5a0C56D370F19fa887a5545d74F52fAC2",
  evc: "0xddcbe30A761Edd2e19bba930A977475265F36Fa1",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x8564160f30926eA1229DCcf24118c6De155D2e30",
  sequenceRegistry: "0x9C38f923baC407C818312EADEf69AdC116fd16FD",
} as const
